// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__3anZ_"};